// extracted by mini-css-extract-plugin
var _1 = "_cgnriHeyqd3ajKPIqWg";
var _2 = "B9FpkKY6NrwGviEBvyDT";
var _3 = "I7r5gwowI76q2fYNxO4A";
export { _1 as "inverted", _2 as "loader", _3 as "spin" }
